import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingService } from './setting.service';
import { SchoolProgramActivityModel } from '../models/school-program-activity-model';
import { Observable } from 'rxjs';
import { RuleModel } from '../models/rule.model';

@Injectable()
export class RulesService {

  constructor(
    private settings: SettingService,
    private http: HttpClient
  ) {}

  api = 'school-program-http/api/v1';

  // GLOBAL RULES
  getGlobalRules(data: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/global-rules';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program/global-rules';

    return this.http.post<any>(requestUrl, JSON.parse(JSON.stringify(data)), this.settings.httpOptionWithSession());
  }

  getGlobalRulesDetail(id: number) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/global-rules/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program/global-rules/' + id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  addGlobalRules(data: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/global-rules';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program/global-rules';

    return this.http.put<any>(requestUrl, JSON.parse(JSON.stringify(data)), this.settings.httpOptionWithSession());
  }

  addGlobalRulesForAll(data: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/global-rules-all';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program/global-rules-all';

    return this.http.put<any>(requestUrl, JSON.parse(JSON.stringify(data)), this.settings.httpOptionWithSession());
  }

  updateGlobalRules(data: any) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/global-rules';
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program/global-rules';

    return this.http.patch<any>(requestUrl, JSON.parse(JSON.stringify(data)), this.settings.httpOptionWithSession());
  }

  deleteGlobalRules(id: number) {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/global-rules/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program/global-rules/' + id;

    return this.http.delete<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  getLocationGlobalRules(id: number): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/global-rules-by-location/' + id;
    // const requestUrl = 'http://localhost:3075/school-program-http/api/v1/school-program/global-rules-by-location/' + id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  // RULE PER YEAR LEVEL
  getRuleList(param: any): Observable<RuleModel[]> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/rule/list';
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/rule/list';

    return this.http.post<any>(requestUrl,param, this.settings.httpOptionWithSession());
  }

  getStudentRule(param: any): Observable<any> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/rule-student';
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/rule-student';

    return this.http.post<any>(requestUrl, param, this.settings.httpOptionWithSession());
  }

  saveRule(param: any): Observable<SchoolProgramActivityModel[]> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/rule/create';
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/rule/create';

    return this.http.post<any>(requestUrl, param, this.settings.httpOptionWithSession());
  }

  deleteRule(id: number): Observable<SchoolProgramActivityModel[]> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/rule/' + id;
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/rule/' + id;

    return this.http.delete<any>(requestUrl, this.settings.httpOptionWithSession());
  }

  updateRule(param: any): Observable<SchoolProgramActivityModel[]> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/rule/update';
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/rule/update';

    return this.http.post<any>(requestUrl, param, this.settings.httpOptionWithSession());
  }

  getRuleDetail(id: number): Observable<SchoolProgramActivityModel[]> {
    const requestUrl = this.settings.getConfig('api.url') + '/' + this.api + '/school-program/rule/' + id;
    // const requestUrl = 'http://localhost:3075' + '/' + this.api + '/school-program/rule/' + id;

    return this.http.get<any>(requestUrl, this.settings.httpOptionWithSession());
  }

}
